<div class="menu-header">

  <h4 class="menu-header-title">{{ title }}</h4>

  <span class="menu-header-desc">{{ description }}</span>

</div>